import api from './';
import { normalizeSetupIntent } from '@/helpers/normalizers';

export default {
  create: () => api.post('setup_intents').json().then(normalizeSetupIntent),
};
